/**
 * This file is copy-pasted from @ori/fetching. This package can't be used here as it pulls react and swr to non-react
 * packages.
 */
var BEARER = 'Bearer ';
/**
 * Composes a token string with a "Bearer" prefix if it doesn't already have one.
 * @param {string} token - The `token` parameter is a string representing an authentication token.
 */
export var composeToken = function (token) { return (token.includes(BEARER) ? token : "".concat(BEARER).concat(token)); };
/**
 * Formats a token string if it exists, otherwise it returns undefined.
 * @param {string | null | undefined} token - The `token` parameter is a string that can also be `null`
 * or `undefined`.
 */
export var formatToken = function (token) {
    return token ? composeToken(token) : undefined;
};

